import { render, staticRenderFns } from "./GradeItem.vue?vue&type=template&id=72202d13&scoped=true&"
import script from "./GradeItem.vue?vue&type=script&lang=js&"
export * from "./GradeItem.vue?vue&type=script&lang=js&"
import style0 from "./GradeItem.vue?vue&type=style&index=0&id=72202d13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72202d13",
  null
  
)

export default component.exports